import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IApplicationState } from 'Store/types'
import {
  removeNotHealthyAutoPart,
  saveVisit,
  setNotHealthyAutoPartFileContent,
} from '../../Actions/reducer'
import { useTranslation } from 'react-i18next'
import {
  getUploadLink,
  uploadNotHealthyAutoPartsFiles,
  uploadNotHealthyAutoPartsFilesPodSpace,
} from '../../Actions/action'
import NotHealthyNewAutoPart from './NotHealthyNewAutoPart'
import Icon from 'Components/Icon'
import PodSpaceImage from 'Components/Image/PodSpaceImage'
import { useNetStatus } from 'Contexts/NetStatusContext'
import Consts from 'Utils/Consts'
import { useSettings } from 'Contexts/SettingsContext'

const NotHealthyAutoPartsPage = (props: { handleNext: () => void; handleBack: () => void }) => {
  const [t] = useTranslation()
  const { data, loading } = useSelector(
    (store: IApplicationState) => store.visits.newVisit.notHealthyAutoParts,
  )
  const { uploadLink } = useSelector((store: IApplicationState) => store.visits.newVisit)
  const { storeFileType } = useSelector((store: IApplicationState) => store.visits.newVisit)
  const { link } = useSelector((store: IApplicationState) => store.visits.newVisit.uploadLink)
  const { netStatus } = useNetStatus()
  const { settings } = useSettings()
  const [mode, setMode] = useState<'LIST' | 'NEW'>('LIST')
  const dispatch = useDispatch()

  const uploadLinkSize =
    (settings?.REACT_APP_UPLOAD_LINK_SIZE ?? Consts.env.REACT_APP_UPLOAD_LINK_SIZE) || 10200

  const onNextHandleClick = () => {
    if (netStatus != 'MANUAL_OFF') {
      if (storeFileType == 'POD_SPACE') {
        // if (link) {
        //   dispatch(uploadNotHealthyAutoPartsFilesPodSpace({ handleNext: props.handleNext, uploadLink: link }))
        // } else {
        dispatch(
          getUploadLink({
            data: { sizeInKB: uploadLinkSize, visitId: 0, type: 3 },
            handleNext: props.handleNext,
          }),
        )
        // }
      } else {
        dispatch(uploadNotHealthyAutoPartsFiles(props.handleNext))
      }
    } else {
      dispatch(saveVisit())
      props.handleNext()
    }
  }

  return (
    <React.Fragment>
      <div className="flex flex-col grow overflow-auto">
        <div className="px-6 pb-6">
          <div className="text-sm mb-8">{t('REGISTER-THE-DAMAGED-PART-ALONG-WITH-ITS-IMAGE')}</div>

          {mode == 'LIST' ? (
            <React.Fragment>
              {data.length == 0 && (
                <div
                  id="alert-info"
                  className="flex items-center p-3 text-white rounded-xl bg-gray-800 dark:bg-gray-800 mb-3"
                  role="alert"
                >
                  <div className="bg-info/[.16] text-info p-2 rounded-lg flex justify-center items-center">
                    <Icon name="ic_info" className="w-6 h-6" />
                  </div>
                  <span className="sr-only">info</span>
                  <div className="ms-3 text-sm font-semibold grow">
                    {t('REQUIRED_NOT_HEALTHY_AUTO_PART_MESSAGE')}
                  </div>
                </div>
              )}

              <div className="flex flex-wrap gap-4">
                <div className="flex gap-4" onClick={() => setMode('NEW')}>
                  <div className="h-36 bg-primary/[.08] hover:bg-primary/[.16] min-w-[163px] text-primary text-xs border border-primary border-dashed rounded-lg flex flex-col gap-2 justify-center items-center bg-cover bg-no-repeat bg-center">
                    <Icon name="camera" className="w-6 h-6" />
                    {t('NEW_AUTO_PART')}
                  </div>
                </div>

                {data.map((x, i) => {
                  return (
                    <div
                      style={{ position: 'relative' }}
                      className={loading && Number(x?.status) != 1 ? 'loading' : ''}
                    >
                      <PodSpaceImage
                        isPodSpace={storeFileType == 'POD_SPACE'}
                        className="flex flex-col justify-between w-40 h-36 rounded-lg border border-dashed border-gray-500 bg-cover bg-no-repeat bg-center overflow-hidden"
                        hashFile={x?.hashFile}
                        fileId={x?.fileId}
                        fileContent={x?.image}
                        onLoad={(image: string) =>
                          dispatch(setNotHealthyAutoPartFileContent({ id: x?.id, image }))
                        }
                      >
                        {x && (
                          <div
                            className="border-gray-950 text-gray-950 self-end m-1 w-5 h-5 flex justify-center items-center"
                            onClick={() => dispatch(removeNotHealthyAutoPart(x.id))}
                          >
                            <Icon name="close-square" className="w-6 h-6" />
                          </div>
                        )}
                        <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                          {x.name}
                        </div>
                      </PodSpaceImage>

                      {Number(x?.status) == 1 ? (
                        <span style={{ position: 'absolute', top: 5, right: 5, fontSize: 10 }}>
                          {t('UPLOADED')}
                        </span>
                      ) : (
                        ''
                      )}

                      {loading &&
                        Number(x?.status) != 1 &&
                        Number(x?.uploadProgress) > 0 &&
                        Number(x?.uploadProgress) < 100 && (
                          <span
                            style={{ position: 'absolute', top: 5, right: 5, fontSize: 10 }}
                          >{`%${Math.round(Number(x?.uploadProgress))}`}</span>
                        )}
                    </div>
                  )
                })}
              </div>
            </React.Fragment>
          ) : (
            <NotHealthyNewAutoPart onCapture={() => setMode('LIST')} />
          )}
        </div>
      </div>

      <div className="cta">
        <div className="flex justify-between items-center gap-2">
          <button
            className="btn btn-warning btn-lg flex gap-2 items-center justify-center w-full"
            disabled={uploadLink.loading || loading}
            onClick={() => (mode == 'LIST' ? props.handleBack() : setMode('LIST'))}
          >
            <Icon name="arrow-right" className="w-6 h-6" />
            {t('BACK')}
          </button>
          <button
            className="btn btn-primary btn-lg flex gap-2 items-center justify-center w-full"
            disabled={uploadLink.loading || loading || data.length == 0 || mode == 'NEW'}
            onClick={onNextHandleClick}
          >
            {t('NEXT')}
            <Icon name="arrow-left" className="w-6 h-6" />
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

export default NotHealthyAutoPartsPage
